import { Action } from '@ngrx/store';
import { HttpError, PointsSummary } from '@rd/types';

export enum PointsSummaryActionTypes {
  LOAD_POINTS_SUMMARY = '[PointsSummary] Load PointsSummary',
  LOAD_POINTS_SUMMARY_SUCCESS = '[PointsSummary] Load PointsSummary Success',
  LOAD_POINTS_SUMMARY_FAIL = '[PointsSummary] Load PointsSummary Fail',
}

export class LoadPointsSummary implements Action {
  readonly type = PointsSummaryActionTypes.LOAD_POINTS_SUMMARY;
}

export class LoadPointsSummarySuccess implements Action {
  readonly type = PointsSummaryActionTypes.LOAD_POINTS_SUMMARY_SUCCESS;

  constructor(public payload: PointsSummary) {}
}

export class LoadPointsSummaryFail implements Action {
  readonly type = PointsSummaryActionTypes.LOAD_POINTS_SUMMARY_FAIL;

  constructor(public payload: HttpError) {}
}

export type PointsSummaryActions =
  | LoadPointsSummary
  | LoadPointsSummarySuccess
  | LoadPointsSummaryFail;
